import { FormField } from '@domgen/dgx-fe-forms/layout';
import { CmsModelAndSerialNumberFieldset } from './cms-model-and-serial-number-fieldset.interface';
import { CmsPersonFieldset } from './cms-person-fieldset.interface';

export interface CmsApplianceDetailsSteppedForm {
  applianceCategoryCodeField: FormField;
  applianceCodeField: FormField;
  applianceBuiltInCodeField: FormField;
  brandCodeField: FormField;
  modelAndSerialNumberFieldset: CmsModelAndSerialNumberFieldset;
  personFieldset: CmsPersonFieldset;
  purchaseDateField: FormField;
  purchasePriceField: FormField;
  retailerField: FormField;
  warrantyField: FormField;
}
